module.exports = __webpack_public_path__ + "img/LVMH-ch-pix.190a05c7.jpg";